import CatchyCheckbox from "../CatchyCheckbox/CatchyCheckbox";
import CheckBox from "./CheckBox";
import { useState } from "react";

export default function ZabanKharejiSingle({
  title,
  handleState,
  skill,
  state,
  zabanKhareji,
}) {
  const [options, setOptions] = useState({
    عدم‌نیاز: false,
    خیلی‌کم: false,
    کم: false,
    تاحدودی: false,
    زیاد: false,
    خیلی‌خوب: false,
  });
  const handleOptions = (key) => {
    console.log(key);
    Object.keys(options).forEach((key) => {
      if (options[key]) {
        options[key] = false;
      }
    });
    setOptions({
      ...options,
      [key]: !options[key],
    });
    let newOption = {
      ...options,
      [key]: !options[key],
    };
   const data = {...zabanKhareji , [title]: { ...state, [skill]: newOption }}
    handleState(data);
  };

  const optionsJSX = Object.keys(options).map((key, index) => (
    <CatchyCheckbox
      key={index}
      label={key}
      data={zabanKhareji[title][skill]}
      handleCheck={() => handleOptions(key)}
    />
  ));

  return (
    <div className="w-full flex flex-row items-center justify-between">
      <div className="w-32 p-2">
        <span className="text-[14px] text-[#444444] font-semibold text-center mx-auto">
          {skill + ":"}
        </span>
      </div>
      <div className=" w-full text-[14px] text-[#7A7A7A] flex flex-row justify-between">
        {optionsJSX}
      </div>
    </div>
  );
}
